import type { InvoiceOverview } from '@weft/api-definition';
import { INVOICE_REVIEW_STATUSES, SYNC_STATUSES } from '@weft/types';

export function useFilteredSyncSelectedInvoices(selectedInvoices: InvoiceOverview[]): InvoiceOverview[] {
  return selectedInvoices.filter(invoice => invoice.reviewStatus === INVOICE_REVIEW_STATUSES.Approved && invoice.syncStatus !== SYNC_STATUSES.Synced);
}
